import { encode as base64_encode } from 'base-64';
import React from 'react';
import { Breadcrumb } from 'react-materialize';
import './Breadcrumbs.css';

const { REACT_APP_URL_INSTANCE } = process.env;

export default class Breadcrumbs extends React.Component {
  GoHomePage = () => {
    const redirectTo = base64_encode('NavigationBar,HomePage');

    document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}`;
  };

  render() {
    return (
      <div>
        <Breadcrumb cols={12} className="no-shadows">
          <a onClick={this.GoHomePage}>Home</a>
          <a onClick={this.GoHomePage}>Oportunidades</a>
        </Breadcrumb>
      </div>
    );
  }
}
